import type { TicketStatus } from '../stores/support';

// Map a ticket status to a Badge tone (the localized label lives in i18n under
// `support.status.*`). Keeps the colour mapping in one place across the views.
export function ticketStatusTone(
  status: TicketStatus,
): 'neutral' | 'info' | 'warning' | 'success' {
  switch (status) {
    case 'open':
      return 'info';
    case 'in_progress':
      return 'warning';
    case 'answer':
      return 'success';
    case 'closed':
      return 'neutral';
    default:
      return 'neutral';
  }
}

// The tone of the "escalated" badge (#390). One place, like the status tones
// above, so the list and the detail page agree: escalation means the ticket
// sits in the sysadmin queue, which is the loudest state a ticket has.
export function ticketEscalationTone(): 'danger' {
  return 'danger';
}
